import { Box, Text, Center, Heading, Flex } from "@chakra-ui/react";
import BaseLayout from "../../components/base_layout";
import BoardNavigation from "../../components/navi/boardNavi";

export default function PolicyPrivacy() {
  return (
    <BaseLayout>
      <Box className="base_container">
        <Box className="center">
          <Flex
            color="white"
            templateRows="repeat(2, 1fr)"
            templateColumns="repeat(5, 1fr)"
            gap={4}
            className="center-body"
          >
            <BoardNavigation />
            <Box width="20px" />

            <Center mt="10" className="service-body">
              <Heading className="service-title">개인정보취급방침</Heading>

              <Box className="service-box">
                <Text className="service-box-title">
                  파츠고(이하 ‘회사’라 한다)가 운영하는 플랫폼 홈페이지(이하
                  ‘홈페이지’라 한다)에서 수집하게 될 개인정보는 개인정보보호법
                  제15조에 따라 개인정보의 수집ㆍ이용 시 본인의 동의를 얻어야
                  하는 정보입니다.
                </Text>
                <Text className="service-box-title">
                  이에 회사는 아래 내용과 같이 개인정보를 수집ㆍ이용하고자
                  합니다. 홈페이지 이용자는 동의를 거부할 수 있습니다. 다만, 이
                  경우 회원가입 및 제공 서비스에 제한이 있을 수 있습니다.
                </Text>
              </Box>

              <Box className="service-box">
                <Text className="service-box-title">
                  1. 개인정보의 수집 및 이용목적
                </Text>
                <Text className="service-box-content">
                  회사는 수집한 개인정보를 다음의 목적을 위해 활용합니다.
                </Text>
                <Text className="service-box-content">
                  ο 서비스 제공에 관한 계약 이행 및 서비스 제공에 따른 정보 전달
                </Text>
                <Text className="service-box-content">ο 회원 관리</Text>
                <Text className="service-box-content">
                  회원제 서비스 이용에 따른 본인확인 , 개인 식별, 불량회원의
                  부정 이용 방지와 비인가 사용방지, 가입의사확인, 만 14세 미만
                  아동 개인정보 수집 시 법정 대리인 동의여부 확인, 불만처리 등
                  민원처리 및 고지사항 전달
                </Text>
                <Text className="service-box-content">
                  ο 기타 : 개인 맞춤 서비스 제공을 위한자료
                </Text>
              </Box>
              <Box className="service-box">
                <Text className="service-box-title">
                  2. 수집하는 개인정보 항목
                </Text>
                <Text className="service-box-content">
                  회사는 회원가입, 상담, 서비스 신청 등을 위해 아래와 같은
                  개인정보를 수집하며, 이에 대한 동의를 얻고 있습니다.
                </Text>
                <Text className="service-box-content">[일반파트너]</Text>
                <Text className="service-box-content">
                  -필수항목 : 아이디(이메일), 비밀번호
                </Text>
              </Box>
              <Box className="service-box">
                <Text className="service-box-title">[기업파트너]</Text>
                <Text className="service-box-content">
                  -필수항목 : 이름, 아이디(이메일), 비밀번호, 휴대폰번호,
                  사업자등록번호, 상호
                </Text>
              </Box>
              <Box className="service-box">
                <Text className="service-box-title">[기타]</Text>
                <Text className="service-box-content">
                  서비스 이용과정에서 아래와 같은 정보들이 자동으로 생성되어
                  수집될 수 있습니다.
                </Text>
                <Text className="service-box-content">
                  IP Address, 쿠키, 서비스 이용 기록, 접속로그, 이용정지기록
                </Text>
                <Text className="service-box-content">
                  ο 개인정보 수집방법 : 홈페이지
                </Text>
              </Box>
              <Box className="service-box">
                <Text className="service-box-title">
                  3. 개인정보의 보유 및 이용기간
                </Text>
                <Text className="service-box-content">
                  원칙적으로, 개인정보 수집 및 이용목적이 달성된 후에는 해당
                  정보를 지체 없이 파기합니다.
                </Text>
                <Text className="service-box-content">
                  단, 관계법령의 규정에 의하여 보존할 필요가 있는 경우 회사는
                  아래와 같이 관계법령에서 정한 일정한 기간 동안 회원정보를
                  보관합니다.
                </Text>
              </Box>
              <Box className="service-box">
                <Text className="service-box-content">
                  ● 회원 가입 및 관리 기록: 1년, 다만 채권/채무관계 잔존 시에는
                  해당 채권/채무관계 정산 시까지
                </Text>
                <Text className="service-box-content">
                  ● 계약 또는 청약철회 등에 관한 기록: 5년, 다만 당사와
                  파트너와의 계약을 위해 파트너가 제공하는 신원정보는 파트너의
                  업무가 종료된 때로부터 5년까지
                </Text>
                <Text className="service-box-content">
                  ● 대금결제 및 재화 등의 공급에 관한 기록: 5년
                </Text>
                <Text className="service-box-content">
                  ● 소비자의 불만 또는 분쟁처리에 관한 기록: 3년
                </Text>
                <Text className="service-box-content">
                  ● 표시/광고에 관한 기록: 1년
                </Text>
              </Box>
              <Box className="service-box">
                <Text className="service-box-title">
                  4. 개인정보 처리 및 제공
                </Text>
                <Text className="service-box-content">
                  당사는 고객의 개인정보를 회원 가입 및 이용약관 및 제1조
                  개인정보의 수집 및 이용목적에서 고지한 범위 또는 회원 가입시
                  동의한 범위 및 이용약관에 명시한 범위 내에서 처리하며, 동
                  범위를 넘어 처리하거나 제3자에게 제공하지 않습니다.
                </Text>
                <Text className="service-box-content">
                  당사는 고객에 대하여 보다 더 질 높은 서비스 제공 등을 위해
                  아래와 같이 제휴사에게 개인정보를 제공하고 있습니다. 당사는
                  고객님의 개인정보를 당사의 서비스와 무관한 타 기업, 기관에
                  공개하지 않습니다. 단, 고객님의 개인정보를 제공하는 경우는
                  다음과 같으며, 고객님은 제공을 거부할 권리가 있으나 거부하실
                  경우 해당 서비스 제공에 어려움이 있을 수 있습니다.
                </Text>
              </Box>
              <Box className="service-box">
                <Text className="service-box-title">- 제휴 신용카드사</Text>
                <Text className="service-box-content">
                  - 제공 항목: 성명(한글/영문), 휴대전화번호(전화번호), 이메일
                  주소, 주문번호, 구매내역
                </Text>
                <Text className="service-box-content">
                  - 이용 목적: 본인확인, 제휴 서비스 제공 및 관련업무(문의 응대,
                  민원처리 등)
                </Text>
                <Text className="service-box-content">
                  - 제공 기간: 관련 법령에 별도 규정이 명시되어 있는 경우 그
                  해당기간까지
                </Text>
              </Box>
              <Box className="service-box">
                <Text className="service-box-title">
                  - 제휴 택배 사/퀵 서비스업체
                </Text>
                <Text className="service-box-content">
                  - 제공 항목: 성명(한글/영문), 휴대전화번호(전화번호),
                  출발지주소, 도착지주소, 주문번호
                </Text>
                <Text className="service-box-content">
                  - 이용 목적: 제휴 서비스 제공 및 관련업무(문의 응대, 민원처리
                  등)
                </Text>
                <Text className="service-box-content">
                  - 제공 기간: 관련 법령에 별도 규정이 명시되어 있는 경우 그
                  해당기간까지
                </Text>
              </Box>
              <Box className="service-box">
                <Text className="service-box-content">
                  관계법령에 의하거나 수사기관의 요청에 의해 정보를 제공한
                  경우에도 이를 당사자에게 고지하는 것을 원칙으로 운영하고
                  있습니다. 법률상의 근거에 의해 부득이하게 고지를 하지 못할
                  수도 있습니다. 본래의 수집 및 이용목적에 반하여 무분별하게
                  정보가 제공되지 않도록 최대한 노력하겠습니다.
                </Text>
                <Text className="service-box-content">
                  당사는 새로운 기술개발이나 보다 나은 서비스의 제공을 위하여
                  이용자들의 개인정보를 제공할 수 있습니다. 이 경우에도 정보제공
                  이전에 개인정보를 제공할 기관이나 단체가 누구인지, 어떤 정보가
                  왜 필요한지, 그리고 언제까지 어떻게 보호되고 관리되는지
                  알려드리고 동의를 구하는 절차를 거치게 되며, 이용자들의 동의가
                  없는 경우에는 추가적인 정보를 임의로 수집하거나 제공하지
                  않습니다.
                </Text>
              </Box>
              <Box className="service-box">
                <Text className="service-box-title">
                  5. 개인정보의 취급위탁
                </Text>
                <Text className="service-box-content">
                  당사는 원활한 개인정보 업무처리를 위하여 개인정보 처리업무 중
                  일부를 다음과 같이 외부에 위탁할 수 있으며, 위탁 받은 업체가
                  관계 법령을 위반하지 않도록 관리·감독하고 있습니다. 회사가
                  개인정보처리를 위탁한 업체는 다음과 같습니다.
                </Text>
                <Text className="service-box-content">
                  [서비스 이용을 위해 국내업체에 개인정보의 처리를 위탁하는
                  경우]
                </Text>
                <Text className="service-box-content">- 회사명 : 로젠택배</Text>
                <Text className="service-box-content">
                  - 제공 항목: 상품 제휴 배송
                </Text>
                <Text className="service-box-content">
                  - 보유및이용기간: 회원탈퇴 시 혹은 위탁계약 종료 시 까지,
                  법령이 정한 시점
                </Text>
              </Box>
              <Box className="service-box">
                <Text className="service-box-content">
                  - 회사명 : (주)케이지이니시스
                </Text>
                <Text className="service-box-content">
                  - 제공 항목: 전자 결제 서비스
                </Text>
                <Text className="service-box-content">
                  - 보유및이용기간: 별도로 저장하지 않음 (인증 완료 후 지체없이
                  파기)
                </Text>
              </Box>
              <Box className="service-box">
                <Text className="service-box-content">
                  [서비스 이용을 위해 해외업체에 개인정보의 처리를 위탁하는
                  경우]
                </Text>
                <Text className="service-box-content">
                  - 회사명 : OneSignal(https://https://onesignal.com/)
                </Text>
                <Text className="service-box-content">
                  - 제공 항목: 앱/웹 푸시 발송
                </Text>
                <Text className="service-box-content">
                  - 보유및이용기간: 회원탈퇴 시 혹은 위탁계약 종료 시까지
                </Text>
                <Text className="service-box-content">
                  - 위탁의 일시 및 방법: 가입 및 서비스 이용 시점에 네트워크를
                  통한 전송
                </Text>
              </Box>
              <Box className="service-box">
                <Text className="service-box-content">
                  - 회사명 : NHN Cloud(https://www.nhncloud.com), 네이버클라우드
                </Text>
                <Text className="service-box-content">
                  - 제공 항목: 이메일 발송
                </Text>
                <Text className="service-box-content">
                  - 보유및이용기간: 회원탈퇴 시 혹은 위탁계약 종료 시까지
                </Text>
                <Text className="service-box-content">
                  - 위탁의 일시 및 방법: 가입 및 서비스 이용 시점에 네트워크를
                  통한 전송
                </Text>
              </Box>
              <Box className="service-box">
                <Text className="service-box-content">
                  당사는 위탁계약 체결시 「개인정보 보호법」 제26조에 따라
                  위탁업무 목적 및 범위, 위탁업무 수행목적 외 개인정보 처리금지,
                  재위탁 제한, 수탁자에 대한 관리, 감독, 안정성 확보 조치 및
                  책임에 관한 사항을 문서에 명시하고, 수탁자가 개인정보를
                  안전하게 처리하는지를 감독합니다.
                </Text>
                <Text className="service-box-content">
                  당사는 위탁업무의 내용이나 수탁자가 변경될 경우에는 최대한
                  신속하게 본 개인정보 처리방침을 통하여 공개하도록 하겠습니다.
                </Text>
              </Box>
              <Box className="service-box">
                <Text className="service-box-title">
                  6. 인터넷 접속정보파일(쿠키, Cookie) 설정
                </Text>
                <Text className="service-box-content">
                  당사는 고객 개개인에게 개인화되고 맞춤화 된 서비스를 제공하기
                  위해서 이용자의 정보를 저장하고 수시로 불러오는
                  '쿠키(cookie)'를 사용합니다. 쿠키는 웹사이트를 운영하는데
                  이용되는 서버가 사용자의 브라우저에 보내는 아주 작은 데이터
                  꾸러미로서 회원의 단말기(PC, 스마트폰, 태블릿 PC 등)의
                  하드디스크에 저장되며, 웹브라우저의 종료 시나 로그아웃(Logout)
                  시 만료됩니다.
                </Text>
                <Text className="service-box-content">
                  쿠키의 사용 목적 : 쿠키를 통해 고객이 선호하는 설정 등을
                  저장하여 고객에게 더욱 빠른 웹 환경을 지원하며, 편리한 이용을
                  위한 서비스 개선에 활용합니다. 이를 통해 고객은 더욱 손쉽게
                  서비스를 이용할 수 있게 됩니다.
                </Text>
                <Text className="service-box-content">
                  쿠키의 설치∙운영 및 거부 : 고객은 쿠키 설치에 대한 선택권을
                  가지고 있으며, 언제든지 이러한 쿠키의 저장을 거부하거나 삭제할
                  수 있습니다. 쿠키 저장을 거부하는 경우 마이리얼트립 플랫폼의
                  일부 또는 전체가 제대로 작동하지 않을 수 있습니다.
                </Text>
                <Text className="service-box-content">
                  쿠키 설정 거부 방법 : 고객은 당사의 보안 정책을 통해
                  쿠키(Cookie)에 의한 정보수집의 허용 거부 여부를 결정하실 수
                  있습니다. 고객은 브라우저 툴바의 도움말(Help)을 통해 쿠키를
                  거부하도록 브라우저를 설정할 수 있습니다. 플래쉬 쿠키 관리
                  방법에 관한 자세한 내용은 Adobe 웹사이트 초기 화면 하단에
                  ‘쿠키’란을 참고하실 수 있습니다. 고객은 모바일 기기에서 설정
                  기능을 통해 쿠키를 관리할 수 있습니다.
                </Text>
              </Box>
              <Box className="service-box">
                <Text className="service-box-title">
                  7. 개인정보보호 책임자 및 담당부서
                </Text>
                <Text className="service-box-content">
                  회사는 이용자가 좋은 정보를 안전하게 이용할 수 있도록 최선을
                  다하고 있습니다.
                </Text>
                <Text className="service-box-content">
                  개인정보를 보호하는데 있어 이용자에게 고지한 사항들에 반하는
                  사고가 발생할 시에 개인정보보호 책임자가 책임을 집니다.
                </Text>
                <Text className="service-box-content">
                  그러나 관리적, 기술적인 보완조치를 취했음에도 불구하고 해킹 등
                  기본적인 네트워크상의 위험성에 의해 발생하는 예기치 못한
                  사고로 인한 정보의 훼손 및 방문자가 작성한 게시물에 의한 각종
                  분쟁에 관해서는 책임이 없습니다.
                </Text>
                <Text className="service-box-content">
                  회사는 개인정보 관련 문의사항 및 불만 처리 등을 위하여 아래와
                  같이 개인정보 보호책임자 및 담당부서를 지정하고 있습니다.
                </Text>
              </Box>
              <Box className="service-box">
                <Text className="service-box-content">
                  ● 개인정보보호 책임자
                </Text>
                <Text className="service-box-content">담당자 : 이종철</Text>
                <Text className="service-box-content">
                  전자우편 : develop@partsgo.co.kr
                </Text>
                <Text className="service-box-content">
                  전화번호 : 070-4742-4989
                </Text>
              </Box>
              <Box className="service-box">
                <Text className="service-box-content">
                  ● 개인정보보호 담당부서
                </Text>
                <Text className="service-box-content">부서명 : 파츠고 R&D</Text>
                <Text className="service-box-content">
                  전자우편 : develop@partsgo.co.kr
                </Text>
                <Text className="service-box-content">
                  전화번호 : 070-4742-4989
                </Text>
              </Box>
              <Box className="service-box">
                <Text className="service-box-title">
                  8. 개인정보 취급방침 변경
                </Text>
                <Text className="service-box-content">
                  가. 당사의 개인정보 취급방침은 대한민국의 법률 개정과 당사의
                  내부 정책 변동에 따라 변경될 수 있습니다.
                </Text>
                <Text className="service-box-content">
                  나. 당사가 개인정보 취급방침을 개정하는 경우, 당사는
                  변경사항을 파츠고 공지사항에 그 적용일자 7일 이전부터 적용일자
                  전일까지 공지하거나 개별공지합니다. 다만, 수집하는 개인정보의
                  항목, 이용목적의 변경 등과 같이 이용자 권리의 중대한 변경이
                  발생할 때에는 최소 30일 전에 공지하며, 필요 시 이용자 동의를
                  다시 받을 수도 있습니다.
                </Text>
              </Box>
              <Box className="service-box">
                <Text className="service-box-title">
                  [부칙] (2019년 08월 08일)
                </Text>
                <Text className="service-box-content">
                  1. 이 약관은 2022년 01월 01일부터 적용됩니다.
                </Text>
              </Box>
            </Center>
          </Flex>
        </Box>
      </Box>
    </BaseLayout>
  );
}
